import { TemplateRef } from '@angular/core';

export interface Toast {
  title?: ToastTitle;
  message: ToastMessage;
  template?: ToastTemplate;
  type: ToastType;
  actions?: ToastAction[];
}

export interface InternalToast extends Toast {
  id: ToastId;
  destroy: () => void;
}

export const toastType = {
  neutral: 'neutral',
  success: 'success',
  danger: 'danger',
  info: 'info',
  warning: 'warning',
} as const;

export type ToastType = (typeof toastType)[keyof typeof toastType];

export type ToastTitle = string;

export type ToastMessage = string;

export type ToastTemplate = TemplateRef<unknown>;

export type ToastId = number;

export type ToastActionCallback = () => void;

export interface ToastAction {
  readonly text: string;
  readonly id: number;
  readonly callback: ToastActionCallback;
}

export interface ToastConfig {
  /** Duration in ms before a toast auto-dismisses */
  readonly displayDuration: number;
  /** Maximum number of toasts visible at once */
  readonly maxVisibleCount: number;
  /** Delay in ms between showing consecutive toasts */
  readonly displayDelay: number;
}
